import {
  Module,
  VuexModule,
  getModule,
  Mutation,
} from "vuex-module-decorators";

import { ComBox } from "../../data/models/ComBox";

const name = "comBox";

import store from "@/store";
import { getClientId } from "@/data/repository/ClientRepository";

if (store.state[name]) {
  store.unregisterModule(name);
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class ComBoxVuexModule extends VuexModule {
  comBoxCache = new Map<string, ComBox>();
  comBoxesOfClientCache = new Map<string, ComBox>();

  @Mutation
  cacheComBox(comBox: ComBox) {
    this.comBoxCache.set(comBox.serialNo, comBox);

    if (comBox.currentAssignment?.clientId === getClientId()) {
      this.comBoxesOfClientCache.set(comBox.serialNo, comBox);
    }
  }

  @Mutation
  cacheComBoxesOfClient(comBoxesOfClient: Array<ComBox>) {
    this.comBoxesOfClientCache.clear();

    comBoxesOfClient.forEach((comBox) => {
      this.comBoxCache.set(comBox.serialNo, comBox);
      this.comBoxesOfClientCache.set(comBox.serialNo, comBox);
    });
  }

  @Mutation
  clear() {
    this.comBoxCache.clear();
    this.comBoxesOfClientCache.clear();
  }

  get cachedComBoxes() {
    const cache = this.comBoxCache;

    return function(serialNumber: string) {
      return cache.get(serialNumber);
    };
  }
}

export const ComBoxModule = getModule(ComBoxVuexModule);
